export default __webpack_public_path__ + "img/chevron-up-grey.dd214c08.svg";